import React, { Component, useState, Fragment, useEffect, useRef, useMemo } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';
import LightModeIcon from '@mui/icons-material/LightMode';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppBar, Toolbar, Typography, Button, IconButton, Modal, Grid, Box, TextField, FormControl, Drawer, Menu, Paper, Select, MenuItem } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Card from '@material-ui/core/Card';
import SearchIcon from '@material-ui/icons/Search';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import { PostAddOutlined } from '@mui/icons-material';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { customTheme } from '../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
// import AddUpdateUser from "../AddUpdateUser/AddUpdateUser";
// import SearchUserform from "../SearchUser/SearchUserform";
import useStyles from '../../../StyleComponents/StyleFunctionComponent';
import CircularProgress from '@material-ui/core/CircularProgress';
import AccordionSummary from '@mui/material/AccordionSummary';
import SettingsIcon from '@mui/icons-material/Settings';

import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';

import { API_BASE_URL, token, userLevel, adminId } from '../../../../constants';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const EscortAPIResponse = () => {

    const history = useHistory();

    const [openSidebar, setOpenSidebar] = useState(false);

    const [filterText, setFilterText] = useState("");

    const [data, setData] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [csvDownloading, setCsvDownloading] = useState(false);

    const [csvProgress, setCsvProgress] = useState(0);

    const [error, setError] = useState(null);

    const [perPage, setPerPage] = useState(50);

    const [page, setPage] = useState(0);

    const [search, setSearch] = useState('');

    const [totalCount, setTotalCount] = useState(0);

    const currentDate = new Date();

    const sevenDaysAgo = new Date(currentDate);

    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

    const [fromDate, setFromDate] = useState(sevenDaysAgo.toISOString().split('T')[0]);

    const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);

    const [enquirySource, setEnquirySource] = useState([]);

    const [selectedExecutive, setSelectedExecutive] = useState(null);

    const [executiveOptions, setExecutiveOptions] = useState([]);

    const [selectedState, setSelectedState] = useState(null);

    const [stateOptions, setStateOptions] = useState([]);

    const [selectedBrand, setSelectedBrand] = useState();

    const [brandOptions, setBrandOptions] = useState([]);

    const [status, setStatus] = useState("success");

    // Applied filters change only when Apply/Clear is clicked.

    const [appliedFilters, setAppliedFilters] = useState(null);

    const [viewOpen, setViewOpen] = useState(false);

    const [viewData, setViewData] = useState(null);

   // Finance enquiry transfer - additive functionality

   const [selectedFinanceIds, setSelectedFinanceIds] = useState([]);

   const [financeDialogOpen, setFinanceDialogOpen] = useState(false);

   const [financeSubmitting, setFinanceSubmitting] = useState(false);

   const [financeMessage, setFinanceMessage] = useState('');

   const [financeError, setFinanceError] = useState('');

   const [financeFilters, setFinanceFilters] = useState({

       client_name: 'Tyger',

       state_id: '',

       start_date: '',

       end_date: '',

       move_from: 'apis_leads'

   });

    useEffect(() => {

        const fetchDatabrand = async () => {

            try {

                const config = {

                    headers: {

                        'Content-Type': 'application/json',

                        'Accept': 'application/json',

                        'Authorization': `${token}`,

                    },

                    timeout: Infinity, // Request will never time out

                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);

                const statelist = response.data.data.map(item => ({

                    id: item.brand_id,

                    title: item.brand_name,

                }));

                setBrandOptions(statelist);

            } catch (error) {

                console.error('Error fetching state:', error);

            }

        };

        fetchDatabrand();

    }, []);

    useEffect(() => {

        const fetchDatastate = async () => {

            try {

                const config = {

                    headers: {

                        'Content-Type': 'application/json',

                        'Accept': 'application/json',

                        'Authorization': `${token}`,

                    },

                    timeout: Infinity, // Request will never time out

                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/state-list`, config);

                const statelist = response.data.data.map(item => ({

                    id: item.state_id,

                    title: item.state_name,

                }));

                setStateOptions(statelist);

            } catch (error) {

                console.error('Error fetching state:', error);

            }

        };

        fetchDatastate();

    }, []);

    useEffect(() => {

        const fetchDatalist = async () => {

            try {

                const config = {

                    headers: {

                        'Content-Type': 'application/json',

                        'Accept': 'application/json',

                        'Authorization': `${token}`,

                    },

                    timeout: Infinity, // Request will never time out

                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/executive-list`, config);

                const mappedData = response.data.data.map(item => ({

                    id: item.admin_id,

                    title: item.username,

                }));

                // Include an option for null or empty value

                const optionsWithNull = [

                    { id: null, title: 'Select Executive' },

                    ...mappedData,

                ];

                setExecutiveOptions(optionsWithNull);

                // setExecutiveOptions(mappedData);

            } catch (error) {

                console.error('Error fetching executives:', error);

            }

        };

        fetchDatalist();

    }, []);

    const handleExecutiveChange = (event, newValue) => {
        setSelectedExecutive(newValue);
    };

    const handleStateChange = (event, newValue) => {
        setSelectedState(newValue);
    };

    const handleBrandChange = (event, newValue) => {
        setSelectedBrand(newValue);
    };

    const fetchData = async (from, to, pageNumber, searchQuery,) => {
        setIsLoading(true);
        setError(null); // Reset error state
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `${token}`,
                    'adminId': `${adminId}`,
                    'userLevel': `${userLevel}`,
                },

                timeout: Infinity, // Request will never time out

            };

            const requestData = {

                start_date: appliedFilters?.start_date ?? fromDate,

                end_date: appliedFilters?.end_date ?? toDate,

                pagination: perPage,

                page: page + 1,

                status: appliedFilters?.status ?? status,

                state_id: appliedFilters?.state_id ?? ""

                // search: search,

                // product_brand: selectedBrand,

                // enquiry_source: enquirySource,

                // states: selectedState,

                // executive: selectedExecutive,

                // user_level: userLevel,

                // admin_id: adminId,

            };

            // // Conditionally set executive based on user_level

            // if (userLevel === 'executive') {

            //     requestData.executive = adminId; // Replace selectedExecutive with admin_id

            // } else {

            //     requestData.executive = selectedExecutive;

            // }

            const response = await axios.post(`${API_BASE_URL}/api/admin/v2/api-responses/brand/19`, requestData, config);

            const mappedData = response.data.data.data.map((item, index) => {

                let requestBody = item.request_body;

                let responseBody = item.response;

                return {

                    sr_no: ((page * perPage) + index + 1),

                    id: item.id,

                   sr_no: item.id || "",

                    created_at: item.created_at || "",

                    upload_type: item.upload_type || "",

                    enquiry_id: item.enquiry_id || "",

                    model: item.model || "",

                    user: item.full_name || "",

                    email: item.email || "",

                    mobile: item.mobile || "",

                    state: item.state || "",

                    city: item.city || "",

                    status: item.status || "",

                    taluka: item.taluka || "",

                    request_body: requestBody || "",

                    response: responseBody || "",

                };

            });

            setData(mappedData);

            setTotalCount(response.data.data.total);

            setData(mappedData);

            setTotalCount(response.data.data.total);

            setIsLoading(false);

        } catch (error) {

            console.error("Error fetching data:", error);

            if (axios.isCancel(error)) {

                console.error("Request canceled:", error.message);

                // Handle canceled request (if needed)

            } else {

                if (error.code === 'ECONNABORTED') {

                    setError('The request timed out. Please try again.');

                } else if (error.response) {

                    console.error("Server Error Details:", error.response.data);

                    setError(`Error: ${error.response.status} - ${error.response.statusText}`);

                } else {

                    setError('An error occurred while fetching data.');

                }

            }

        } finally {

            setIsLoading(false);

        }

    };

   const handleDownloadCSV = async () => {
      if (csvDownloading) return;
      const filters = {
          start_date: appliedFilters?.start_date ?? fromDate,
          end_date: appliedFilters?.end_date ?? toDate,
          status: appliedFilters?.status ?? status,
          state_id: appliedFilters?.state_id ?? ""
      };
      if (!filters.start_date || !filters.end_date || filters.start_date > filters.end_date) {
          window.alert("Please select a valid date range.");
          return;
      }
      setCsvDownloading(true);
      setCsvProgress(0);
      try {
          const config = {
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json",
                  "Authorization": `${token}`,
                  "adminId": `${adminId}`,
                  "userLevel": `${userLevel}`
              },
              timeout: 120000
          };
          const endpoint = `${API_BASE_URL}/api/admin/v2/api-responses/brand`;
          const batchSize = 100;
          const allRecords = [];
          let currentPage = 1;
          let expectedTotal = null;
          while (true) {
              const response = await axios.post(endpoint, {
                  ...filters,
                  pagination: batchSize,
                  page: currentPage
              }, config);
              const result = response?.data?.data;
              const records = Array.isArray(result?.data) ? result.data :
                  Array.isArray(result?.data?.data) ? result.data.data :
                  Array.isArray(result) ? result : [];
              if (currentPage === 1) {
                  const reportedTotal = Number(result?.total ?? result?.data?.total);
                  if (Number.isFinite(reportedTotal) && reportedTotal >= 0) expectedTotal = reportedTotal;
              }
              if (!records.length) break;
              allRecords.push(...records);
              setCsvProgress(allRecords.length);
              if (records.length < batchSize || (expectedTotal !== null && allRecords.length >= expectedTotal)) break;
              currentPage += 1;
          }
          if (!allRecords.length) {
              window.alert("No records found for the applied date, state and status filters.");
              return;
          }
          const fields = [
              ["ID", "id"], ["Created At", "created_at"],
              ["Upload Type", "upload_type"], ["Enquiry ID", "enquiry_id"],
              ["Model", "model"], ["Customer Name", "full_name"],
              ["Email", "email"], ["Mobile", "mobile"],
              ["State", "state"], ["City", "city"], ["Taluka", "taluka"],
              ["Status", "status"], ["Request Body", "request_body"],
              ["Response", "response"]
          ];
          const csvValue = value => {
              let text = value == null ? "" : typeof value === "object" ? JSON.stringify(value) : String(value);
              if (/^\s*[=+@-]/.test(text)) text = "'" + text;
              return '"' + text.replace(/"/g, '""') + '"';
          };
          const csv = [
              fields.map(([label]) => csvValue(label)).join(","),
              ...allRecords.map(record => fields.map(([, key]) => csvValue(record[key])).join(","))
          ].join("\r\n");
          const blob = new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `Escort_API_Response_${filters.start_date}_to_${filters.end_date}.csv`;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          // Do not revoke the blob URL immediately; some browsers cancel the download.
          window.setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
          }, 3000);
      } catch (err) {
          console.error("CSV export failed:", err.response?.data || err);
          const details = err.response?.data?.message || err.response?.data?.errors;
          window.alert(`CSV download failed: ${typeof details === "string" ? details : details ? JSON.stringify(details) : err.message || "Unknown error"}`);
      } finally {
          setCsvDownloading(false);
      }
  };

   const source = axios.CancelToken.source();

    const sourceRef = useRef(null);

    useEffect(() => {

        // Create a new cancel token source

        sourceRef.current = axios.CancelToken.source();

        fetchData(fromDate, toDate, page, search);

        // Cleanup function

        return () => {

            // Cancel the request when the component unmounts

            sourceRef.current.cancel('Request canceled by cleanup');

        };

    }, [perPage, page, appliedFilters]); // Empty dependency array

    const handleDateChange = (e) => {

        const { name, value } = e.target;

        if (name === 'fromDate') {

            setFromDate(value);

        } else if (name === 'toDate') {

            setToDate(value);

        }

    };

    const handleStatusChange = (e) => {

        setStatus(e.target.value);

    };

    const handlePerPageChange = (e) => {

        setPerPage(Number(e.target.value));

    };

    const handlePrevious = () => {

        if (page > 0) {

            setPage(page - 1);

        }

    };

    const handleNext = () => {

        setPage(page + 1);

    };

    const handleSearchChange = (e) => {

        setSearch(e.target.value);

    };

    const handleSubmit = (e) => {

        e.preventDefault();

        const nextFilters = {

            start_date: fromDate,

            end_date: toDate,

            status: status,

            state_id: selectedState?.id ?? ""

        };

        setPage(0);

        setAppliedFilters(nextFilters);
        setOpenSidebar(false);

    };

    const handleView = (row) => { setViewData(row);
        setViewOpen(true);
    };

    const handleCloseView = () => {

        setViewOpen(false);

        setViewData(null);

    };

    const clearForm = () => {

        const resetFrom = sevenDaysAgo.toISOString().split('T')[0];

        const resetTo = currentDate.toISOString().split('T')[0];

        setSelectedState(null);

        setFromDate(resetFrom);

        setToDate(resetTo);

        setStatus("success");

        setSearch("");

        setPage(0);

        setAppliedFilters({

            start_date: resetFrom,

            end_date: resetTo,

            status: "success",

            state_id: ""

        });

        setOpenSidebar(false);

    };

    // Checkbox selection persists across pages; select-all only affects visible rows.
   const handleFinanceRowSelect = (id, checked) => {

       const numericId = Number(id);

       if (!Number.isInteger(numericId) || numericId <= 0) return;

       setSelectedFinanceIds(prev => checked

           ? [...new Set([...prev, numericId])]

           : prev.filter(value => value !== numericId));

   };

   const handleFinanceSelectAll = (checked) => {

       const visibleIds = data.map(row => Number(row.id))

           .filter(id => Number.isInteger(id) && id > 0);

       setSelectedFinanceIds(prev => checked

           ? [...new Set([...prev, ...visibleIds])]

           : prev.filter(id => !visibleIds.includes(id)));

   };

   const handleOpenFinanceDialog = () => {

       if (!selectedFinanceIds.length) return;

       setFinanceError('');

       setFinanceMessage('');

       setFinanceFilters({

           client_name: 'Tyger',

           state_id: selectedState?.id ?? '',

           start_date: fromDate,

           end_date: toDate,

           move_from: 'apis_leads'

       });

       setFinanceDialogOpen(true);

   };

   const handleFinanceFilterChange = (event) => {

       const { name, value } = event.target;

       setFinanceFilters(prev => ({ ...prev, [name]: value }));

   };

   const handleSubmitFinance = async () => {

       if (financeSubmitting || !selectedFinanceIds.length) return;

       if (!financeFilters.start_date || !financeFilters.end_date ||

           financeFilters.start_date > financeFilters.end_date) {

           setFinanceError('Please provide a valid start and end date.');

           return;

       }

       const payload = {

           move_type: 1,

           client_name: financeFilters.client_name,

           state_id: financeFilters.state_id === '' ? null : Number(financeFilters.state_id),

           start_date: financeFilters.start_date,

           end_date: financeFilters.end_date,

           move_from: 'apis_leads',

           id_selected: selectedFinanceIds.map(id => ({ id }))

       };

       setFinanceSubmitting(true);

       setFinanceError('');

       setFinanceMessage('');

       try {

           // Verify this URL against your Laravel route for moveFinanceEnquiries.

           const response = await axios.post(

               `${API_BASE_URL}/api/admin/v2/move-finance-enquiries`,

               payload,

               { headers: {

                   'Content-Type': 'application/json',

                   'Accept': 'application/json',

                   'Authorization': `${token}`,

                   'adminId': `${adminId}`,

                   'userLevel': `${userLevel}`

               }}

           );

           const body = response.data;

           if (body?.success === false || body?.status === false || body?.status === 'fail') {

               throw new Error(body?.message || 'Finance enquiry transfer failed.');

           }

           setFinanceMessage(body?.message || 'Finance enquiry request processed.');

           setSelectedFinanceIds([]);

           setFinanceDialogOpen(false);

           // Existing listing remains untouched; refresh using its original function.

           await fetchData(fromDate, toDate, page, search);

       } catch (err) {

           const message = err.response?.data?.message || err.message || 'Unable to move finance enquiries.';

           setFinanceError(typeof message === 'string' ? message : JSON.stringify(message));

       } finally {

           setFinanceSubmitting(false);

       }

   };

   const columns = [

       {
           name: 'finance_select',
           label: 'Select',
           options: {
               filter: false,
               sort: false,
               customHeadLabelRender: () => (
                   <Checkbox
                       color="primary"
                       inputProps={{ 'aria-label': 'Select all visible responses' }}
                       checked={data.length > 0 && data.every(row => selectedFinanceIds.includes(Number(row.id)))}
                       indeterminate={data.some(row => selectedFinanceIds.includes(Number(row.id))) && !data.every(row => selectedFinanceIds.includes(Number(row.id)))}
                       onChange={event => handleFinanceSelectAll(event.target.checked)}
                   />
               ),

               customBodyRenderLite: dataIndex => {
                   const row = data[dataIndex];
                   if (!row) return null;
                   return <Checkbox
                       color="primary"
                       checked={selectedFinanceIds.includes(Number(row.id))}
                       onChange={event => handleFinanceRowSelect(row.id, event.target.checked)}
                       inputProps={{ 'aria-label': `Select response ${row.id}` }}
                   />;
               }
           }
       },
        {
            name: "sr_no",

            label: "S/N",

            options: {

                filter: false,

                sort: false,

            }

        },

        {

            name: "created_at",

            label: "Created At",

            options: {
                filter: true,
                sort: true,
            }
        },

        {

            name: "upload_type",

            label: "Upload Type",

            options: {

                filter: true,

                sort: true,

            }

        },

        {

            name: "enquiry_id",

            label: "Enquiry ID",

            options: {

                filter: true,

                sort: true,

            }

        },

        {

            name: "model",

            label: "Model",

            options: {

                filter: true,

                sort: true,

            }

        },

        {

            name: "user",

            label: "Customer Name",

            options: {

                filter: true,

                sort: true,

            }

        },

        {

            name: "email",

            label: "Email",

            options: {

                filter: true,

                sort: false,

            }

        },

        {

            name: "mobile",

            label: "Mobile",

            options: {

                filter: true,

                sort: false,

            }

        },

        {

            name: "state",

            label: "State",

            options: {

                filter: true,

                sort: true,

            }

        },

        {

            name: "city",

            label: "City",

            options: {

                filter: true,

                sort: true,

            }

        },

        {

            name: "taluka",

            label: "Taluka",

            options: {

                filter: true,

                sort: true,

            }

        },

        {

            name: "status",

            label: "Status",

            options: {

                filter: true,

                sort: true,

            }

        },

        {

            name: "request_body",

            label: "Request Body",

            options: {

                filter: false,

                sort: false,

                customBodyRender: (value) => (

                    <div

                        style={{

                            maxWidth: "350px",

                            maxHeight: "120px",

                            overflow: "auto",

                            whiteSpace: "pre-wrap",

                            fontSize: "12px",

                        }}

                    >

                        {value}

                    </div>

                )

            }

        },

        {

            name: "response",

            label: "Response",

            options: {

                filter: false,

                sort: false,

                customBodyRender: (value) => (

                    <div

                        style={{

                            maxWidth: "350px",

                            maxHeight: "120px",

                            overflow: "auto",

                            whiteSpace: "pre-wrap",

                            fontSize: "12px",

                        }}

                    >

                        {value}

                    </div>

                )

            }

        },

        {

            name: "view",

            label: "View",

            options: {

                filter: false,

                sort: false,

                customBodyRenderLite: (dataIndex) => {

                    const row = data[dataIndex];

                    return (

                        <IconButton

                            size="small"

                            onClick={() => handleView(row)}

                            style={{

                                color: "#1976d2"

                            }}

                        >

                            <VisibilityIcon />

                        </IconButton>

                    );

                }

            }

        }

    ];

    const CustomToolbarAction = ({ toggleFilter }) => (

        <IconButton aria-label="Filter list" onClick={toggleFilter}>

            <FilterListIcon onClick={toggleSidebar} />

        </IconButton>

    );

    useEffect(() => {

        const handleKeyPress = (event) => {

            if (event.shiftKey && event.key === 'F') {

                // Shift + D is pressed, open the sidebar

                setOpenSidebar(true);

            }

        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {

            window.removeEventListener('keydown', handleKeyPress);

        };

    }, []);

    const toggleSidebar = () => {

        setOpenSidebar(!openSidebar);

    };

    const options = {

        rowsPerPage: perPage,

        selectableRows: 'none',

        page: page,

        serverSide: true,

        count: totalCount,

        onTableChange: (action, tableState) => {

            switch (action) {

                case 'changePage':

                    setPage(tableState.page);

                    break;

                case 'changeRowsPerPage':

                    setPerPage(tableState.rowsPerPage);

                    setPage(0);

                    break;

                default:

                    break;

            }

        },

        customToolbar: () => <CustomToolbarAction />,

        filter: false,

        filterType: "dropdown",

        responsive: "standard",

        fixedHeader: true,

        fixedSelectColumn: true,

        overflowy: "auto",

        overflowx: "auto",

        rowsPerPageOptions: [10, 50, 100, 1000, 10000, { value: totalCount, label: 'All' }],

        customFilterDialogFooter: (currentFilter, applyNewFilter) => (

            <div>

                <TextField

                    label="Filter Data"

                    value={filterText}

                    onChange={(e) => setFilterText(e.target.value)}

                    fullWidth

                />

                <Button onClick={applyNewFilter} variant="contained" color="primary">

                    Apply Filter

                </Button>

                <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">

                    Cancel

                </Button>

            </div>

        ),

    };

    const currentTheme = customTheme(true);

    const classes = useStyles();

    const memoizedData = useMemo(() => data, [data]);

    return (

        <>

            <Box sx={{ width: '100%' }}>
                <Grid container>
                    <Grid item xs={6} style={{ marginTop: "8px" }}>
                        <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
                            Escort API Response
                        </Typography>
                    </Grid>

                   <Grid item xs={6} style={{ margin: "auto", padding: "auto", textAlign: "right", marginBottom: "5px" }}>
                                             <Button variant="outlined" color="primary" disabled={csvDownloading}
                          onClick={handleDownloadCSV} style={{ marginRight: 10 }}>
                          {csvDownloading ? `Downloading CSV (${csvProgress} records)...` : "Download CSV (All Filtered Records)"}
                      </Button>

                        <Button variant="contained" color="primary" disabled={!selectedFinanceIds.length} onClick={handleOpenFinanceDialog}>
                           Move to Finance Enquiry ({selectedFinanceIds.length})
                       </Button>

                   </Grid>

                </Grid>

                <hr className={classes.horizontalline} />

            </Box>

            <MuiThemeProvider theme={currentTheme}>

                {

                    isLoading ? (

                        <LinearProgress />

                    ) : (

                        ""

                    )

                }

                <MUIDataTable

                    title={

                        isLoading ? (

                            <Skeleton animation="wave" />

                        ) : (

                            <Typography className={classes.tabletittle} >

                                Escort API Response

                            </Typography>

                        )

                    }

                    data={memoizedData}

                    columns={columns}

                    options={options}

                />

            </MuiThemeProvider>

            {/* Finance transfer popup; does not affect existing View popup. */}

           <Dialog

               open={financeDialogOpen}

               onClose={() => { if (!financeSubmitting) setFinanceDialogOpen(false); }}

               fullWidth

               maxWidth="sm"

           >

               <DialogTitle>Move to Finance Enquiry</DialogTitle>

               <DialogContent dividers>

                   <Grid container spacing={2}>

                       <Grid item xs={12}>

                           <Typography>Selected API Responses: {selectedFinanceIds.length}</Typography>

                       </Grid>

                       <Grid item xs={12}>

                           <TextField select fullWidth variant="outlined" label="Client Name"

                               name="client_name" value={financeFilters.client_name}

                               onChange={handleFinanceFilterChange}>

                               <MenuItem value="Tyger">Tyger</MenuItem>

                           </TextField>

                       </Grid>

                       <Grid item xs={12}>

                           <TextField select fullWidth variant="outlined" label="State"

                               name="state_id" value={financeFilters.state_id}

                               onChange={handleFinanceFilterChange}>

                               <MenuItem value="">All States</MenuItem>

                               {stateOptions.map(item => (

                                   <MenuItem key={item.id} value={item.id}>{item.title}</MenuItem>

                               ))}

                           </TextField>

                       </Grid>

                       <Grid item xs={6}>

                           <TextField fullWidth type="date" variant="outlined" label="Start Date"

                               name="start_date" value={financeFilters.start_date}

                               onChange={handleFinanceFilterChange}

                               InputLabelProps={{ shrink: true }} />

                       </Grid>

                       <Grid item xs={6}>

                           <TextField fullWidth type="date" variant="outlined" label="End Date"

                               name="end_date" value={financeFilters.end_date}

                               onChange={handleFinanceFilterChange}

                               InputLabelProps={{ shrink: true }} />

                       </Grid>

                       <Grid item xs={12}>

                           <TextField fullWidth variant="outlined" label="Move From"

                               value="apis_leads" disabled />

                       </Grid>

                       {financeError && <Grid item xs={12}>

                           <Typography color="error">{financeError}</Typography>

                       </Grid>}

                   </Grid>

               </DialogContent>

               <DialogActions>

                   <Button disabled={financeSubmitting} onClick={() => setFinanceDialogOpen(false)}>Cancel</Button>

                   <Button color="primary" variant="contained"

                       disabled={financeSubmitting || !selectedFinanceIds.length}

                       onClick={handleSubmitFinance}>

                       {financeSubmitting ? 'Submitting...' : 'Submit to Finance'}

                   </Button>

               </DialogActions>

           </Dialog>

           <Dialog open={viewOpen} onClose={handleCloseView} fullWidth maxWidth="md">

                <DialogTitle>

                    Escort API Response Details

                </DialogTitle>

                <DialogContent dividers>

                    {viewData && (

                        <Grid container spacing={2}>

                            <Grid item xs={6}>

                                <b>ID:</b>{" "}

                                {viewData.sr_no || "-"}

                            </Grid>

                            <Grid item xs={6}>

                                <b>Enquiry ID:</b>{" "}

                                {viewData.enquiry_id || "-"}

                            </Grid>

                            <Grid item xs={6}>

                                <b>Created At:</b>{" "}

                                {viewData.created_at || "-"}

                            </Grid>

                            <Grid item xs={6}>

                                <b>Upload Type:</b>{" "}

                                {viewData.upload_type || "-"}

                            </Grid>

                            <Grid item xs={6}>

                                <b>Model:</b>{" "}

                                {viewData.model || "-"}

                            </Grid>

                            <Grid item xs={6}>

                                <b>Status:</b>{" "}

                                {viewData.status || "-"}

                            </Grid>

                            <Grid item xs={6}>

                                <b>Customer Name:</b>{" "}

                                {viewData.user || "-"}

                            </Grid>

                            <Grid item xs={6}>

                                <b>Mobile:</b>{" "}

                                {viewData.mobile || "-"}

                            </Grid>

                            <Grid item xs={6}>

                                <b>Email:</b>{" "}

                                {viewData.email || "-"}

                            </Grid>

                            <Grid item xs={4}>

                                <b>State:</b>{" "}

                                {viewData.state || "-"}

                            </Grid>

                            <Grid item xs={4}>

                                <b>City:</b>{" "}

                                {viewData.city || "-"}

                            </Grid>

                            <Grid item xs={4}>

                                <b>Taluka:</b>{" "}

                                {viewData.taluka || "-"}

                            </Grid>

                            <Grid item xs={12}>

                                <b>Request Body:</b>

                                <pre

                                    style={{

                                        whiteSpace: "pre-wrap",

                                        wordBreak: "break-word",

                                        background: "#f5f5f5",

                                        padding: "10px",

                                        marginTop: "5px",

                                        maxHeight: "250px",

                                        overflow: "auto"

                                    }}

                                >

                                    {viewData.request_body || "-"}

                                </pre>

                            </Grid>

                            <Grid item xs={12}>

                                <b>Response:</b>

                                <pre

                                    style={{

                                        whiteSpace: "pre-wrap",

                                        wordBreak: "break-word",

                                        background: "#f5f5f5",

                                        padding: "10px",

                                        marginTop: "5px",

                                        maxHeight: "250px",

                                        overflow: "auto"

                                    }}

                                >

                                    {viewData.response || "-"}

                                </pre>

                            </Grid>

                        </Grid>

                    )}

                </DialogContent>

                <DialogActions>

                    <Button

                        onClick={handleCloseView}

                        color="primary"

                    >

                        Close

                    </Button>

                </DialogActions>

            </Dialog>

            <Drawer anchor="right" open={openSidebar}

                PaperProps={{

                    style: {

                        width: "100%",

                        maxWidth: 300,

                        padding: "10px"

                    }

                }}

                onClose={() => setOpenSidebar(false)}

            >

                <form onSubmit={handleSubmit}>

                    <Grid container spacing={1}>

                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>

                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />

                        </Grid>

                        <Grid item xs={4} sm={2} lg={12} >

                            <br />

                            <Typography className={classes.tabletittle} >

                                Filter

                            </Typography>

                        </Grid>

                    </Grid>

                    {/* <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>

                        <div className={classes.root}>

                            <Grid container spacing={1}>

                                <Grid item xs={4} sm={2} lg={12} >

                                    <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />

                                </Grid>

                                <Grid item xs={4} sm={2} lg={12}>

                                    <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />

                                </Grid>

                            </Grid>

                        </div>

                    </div> */}

                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>

                        <div className={classes.root}>

                            <Grid container spacing={1}>

                                {/* State filter: same options as finance popup */}

                                <Grid item xs={12} sm={12} lg={12}>

                                    <Autocomplete

                                        options={stateOptions}

                                        getOptionLabel={(option) => option?.title || ""}

                                        value={selectedState || null}

                                        onChange={(event, newValue) => setSelectedState(newValue)}

                                        getOptionSelected={(option, value) => option.id === value.id}

                                        renderInput={(params) => (

                                            <TextField

                                                {...params}

                                                placeholder="Select State"

                                                variant="outlined"

                                                size="small"

                                                fullWidth

                                            />

                                        )}

                                    />

                                </Grid>

                                {/* From Date */}

                                <Grid item xs={4} sm={2} lg={12}>

                                    <input

                                        className={classes.inputform}

                                        type="date"

                                        name="fromDate"

                                        value={fromDate}

                                        onChange={handleDateChange}

                                    />

                                </Grid>

                                {/* To Date */}

                                <Grid item xs={4} sm={2} lg={12}>

                                    <input

                                        className={classes.inputform}

                                        type="date"

                                        name="toDate"

                                        value={toDate}

                                        onChange={handleDateChange}

                                    />

                                </Grid>

                                {/* Status */}

                                <Grid item xs={4} sm={2} lg={12}>

                                    <select

                                        className={classes.inputform}

                                        name="status"

                                        value={status}

                                        onChange={handleStatusChange}

                                    >

                                        <option value="">All Status</option>

                                        <option value="success">Success</option>

                                        <option value="fail">Fail</option>

                                    </select>

                                </Grid>

                            </Grid>

                        </div>

                    </div>

                    <br />

                    <Grid >

                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>

                            {/* <button className={classes.buttonform} type="submit">Fetch Data</button> */}

                            <Button

                                type='submit'

                                style={{ marginRight: "10px" }}

                                className={classes.buttonform}

                                variant="outlined" startIcon={<ApprovalIcon />}>

                                Apply

                            </Button>

                            <Button

                                type="button" onClick={clearForm}

                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}

                                className={classes.buttonform}

                                variant="outlined" startIcon={<ClearIcon />}>

                                Clear

                            </Button>

                        </Grid>

                    </Grid>

                    <br />

                </form>

            </Drawer >

        </>

    );

};

export default EscortAPIResponse;
